import { render, staticRenderFns } from "./newMainNav.vue?vue&type=template&id=9bec9a3e&scoped=true"
import script from "./newMainNav.vue?vue&type=script&lang=js"
export * from "./newMainNav.vue?vue&type=script&lang=js"
import style0 from "./newMainNav.vue?vue&type=style&index=0&id=9bec9a3e&prod&lang=less"
import style1 from "./newMainNav.vue?vue&type=style&index=1&id=9bec9a3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bec9a3e",
  null
  
)

export default component.exports